import { isFunction } from './fns'

export function getNodeIndex(elm) {
    //return [...elm.parentNode.children].findIndex(c => c == elm)
    // or
    return [...elm.parentNode.children].indexOf(elm)
}

export function matchesSelectorToParentElements(el, selector, baseNode) {
    let node = el

    const matchesSelectorFunc = [
        'matches',
        'webkitMatchesSelector',
        'mozMatchesSelector',
        'msMatchesSelector',
        'oMatchesSelector'
    ].find(func => isFunction(node[func]))

    if (!isFunction(node[matchesSelectorFunc])) return false

    do {
        if (node[matchesSelectorFunc](selector)) return true
        if (node === baseNode) return false
        node = node.parentNode
    } while (node)

    return false
}

export function getStyleValue(el, attribute) {
    if (el == null) {
        return 0;
    }

    let value = null;
    try {
        value = (window.getComputedStyle ? window.getComputedStyle(el, null) : getComputedStyle(el, null)).getPropertyValue(attribute);
    } catch (e) {
        value = el.currentStyle[attribute];
    }
    return value;
}

export function getViewPortSize() {
    var w = window,
        d = document,
        e = d.documentElement,
        g = d.getElementsByTagName('body')[0],
        width = w.innerWidth || e.clientWidth || g.clientWidth,
        height = w.innerHeight || e.clientHeight || g.clientHeight;

    return { width, height };
}

export function stringToHTML(str) {
    //exemplo: srt = '<div id="myDiv"></div>';
    var temp = document.createElement('div');
    temp.innerHTML = str;
    var htmlObject = temp.firstChild;
    return htmlObject;
}

export function moverParaNovoParent(novoPai, el) {
    novoPai.appendChild(el);
}